import { ComponentProps, ReactNode } from 'react';
import { WithAccountId } from '@mews-commander/types';
import { EnterpriseLink } from '@mews-commander/ui';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { CompanyDetailTabs } from '../../../companyDetail/enums';

interface Props extends WithAccountId {
    billId: string;
    children: ReactNode;
}

type EnterpriseLinkProps = Omit<ComponentProps<typeof EnterpriseLink>, 'to' | 'params' | 'search'>;

export const CompanyBillingEnterpriseLink = ({
    accountId,
    billId,
    children,
    ...props
}: Props & EnterpriseLinkProps) => (
    <EnterpriseLink
        inherit
        id={billId}
        to="Company/Detail/$id"
        params={{ id: accountId }}
        search={{ tab: CompanyDetailTabs.Billing, billId }}
        {...props}
    >
        {children}
    </EnterpriseLink>
);

export const CustomerBillingEnterpriseLink = ({
    accountId,
    billId,
    children,
    ...props
}: Props & EnterpriseLinkProps) => {
    const enterpriseId = useCurrentEnterpriseId();

    return (
        <EnterpriseLink
            inherit
            id={billId}
            to="Billing/Account/$accountId"
            params={{ accountId }}
            search={{ billId, EnterpriseId: enterpriseId }}
            {...props}
        >
            {children}
        </EnterpriseLink>
    );
};

export const BillDetailEnterpriseLink = ({ accountId, billId, children, ...props }: Props & EnterpriseLinkProps) => (
    <EnterpriseLink inherit id={billId} to="Bill/Detail/$id" params={{ id: billId }} {...props}>
        {children}
    </EnterpriseLink>
);
